var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Webmail Access")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _vm.loading
              ? _c("v-progress-circular", {
                  attrs: {
                    indeterminate: "",
                    size: "64",
                    color: "primary"
                  }
                })
              : _c(
                  "v-form",
                  {
                    attrs: {
                      action: _vm.authUrl,
                      method: "post",
                      target: "_blank"
                    }
                  },
                  [
                    _c("input", {
                      attrs: {
                        type: "hidden",
                        name: "session"
                      },
                      domProps: {
                        value: _vm.session
                      }
                    }),
                    _c(
                      "gg-btn",
                      {
                        attrs: {
                          type: "submit",
                          color: "primary",
                          tile: ""
                        }
                      },
                      [_vm._v("Continue to Webmail")]
                    )
                  ],
                  1
                )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }